//
//
//
//
//
//
//
//
//

import memorymp3 from './assets/music/1.mp3'
import cakemp3 from './assets/music/2.mp3'
import imgmp3 from './assets/music/3.mp3'

export default {
  name: 'app',
  data () {
    return {
      cake_mp3_url: cakemp3,
      img_mp3_url: imgmp3,
      memory_mp3_url: memorymp3
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue